module.exports = __webpack_public_path__ + "img/green-travel.27ac5690.png";